import backend from "../api/api";
import { message } from "antd";
import { store } from "../redux/store";

const getConfig = () => {
  const token = store.getState().auth.token;
  const config = {
    headers: {
      Authorization: `Token ${token}`,
    },
  };
  return config;
};

// ####################### Barcode Print List #######################

// CREATE
export const createBarcodePrintList = (formValues) => async () => {
  // formValues["data"] = "";
  console.log(formValues);
  try {
    const response = await backend.post(
      "api/product/BarcodePrintList/",
      formValues,
      getConfig()
    );
    if (response.status === 201) {
      message.success("Barcode Print List created successfully");
      const barcodePrintList = response.data;
      return barcodePrintList;
    } else {
      throw new Error("Error creating Barcode Print List");
    }
  } catch (error) {
    console.log(error);
  }
};

// READ
export const getBarcodePrintList =(id)=> async () => {
//   console.log(id)
  try {
    const response = await backend.get(
      `api/product/BarcodePrintList/${id}/`,
      getConfig()
    );
    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    console.error("Error fetching Barcode Print List:", error);
    throw error;
  }
};

export const getAllBarcodePrintList = () => async () => {
  try {
    const response = await backend.get(
      `api/product/BarcodePrintList/`,
      getConfig()
    );
    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    console.error("Error fetching Barcode Print List:", error);
    throw error;
  }
};

// UPDATE
export const updateBarcodePrintList = (id, formValues) => async () => {
  try {
    const response = await backend.patch(
      `api/product/BarcodePrintList/${id}/`,
      formValues,
      getConfig()
    );
    if (response.status === 201) {
      message.success("Barcode Print List created successfully");
      const draftCostSheet = response.data;
      return draftCostSheet;
    } else {
      throw new Error("Error creating Barcode Print List");
    }
  } catch (error) {
    console.log(error);
  }
};

// DELETE
export const deleteBarcodePrintList = (id) => async () => {
  try {
    const response = await backend.delete(
      `api/product/BarcodePrintList/${id}/`,
      getConfig()
    );
    if (response.status === 204) {
      message.success("Barcode Print List deleted successfully");
    }
  } catch (error) {
    console.error("Error deleting Barcode Print List:", error);
    throw error;
  }
};